export enum Time {
  ONE_HOUR = 1000 * 60 * 60,
  HALF_HOUR = 1000 * 60 * 30,
  QUARTER_HOUR = 1000 * 60 * 15,
  ONE_MINUTE = 1000 * 60,
  HALF_MINUTE = 1000 * 30,
  QUARTER_MINUTE = 1000 * 15,
  FIVE_SECONDS = 1000 * 5,
  ONE_SECOND = 1000,
}
